module.exports = __webpack_public_path__ + "static/media/Wipe-Sad-Look.837c0977.png";